<script>
import ListDefault from "../../Utils/Page/ListDefault";

export default {
    name: "List",
    mixins: [ListDefault],
    data() {
        return {
            lang: this.$ml.get('pages.company'),

            buttons: [
                {
                    key: 'export',
                    class: 'btn-primary',
                    function: this.exportData
                }
            ],

            filter: {
                company_name: { value: null, type: 'text'},
            },

            tableHeader: [
                //{ label: '#', is_sort: false },
                { key: 'id', is_sort: true },
                { key: 'logo', is_sort: true, classes: 'text-l' },
                { key: 'company_name', is_sort: true, classes: 'text-l' },
                { key: 'email', is_sort: true, classes: 'text-l' },
                { key: 'industry', is_sort: true, classes: 'text-l' },
                { key: 'user_id', is_sort: true, classes: 'text-l' },
                { key: 'email_subscription', is_sort: true, classes: 'text-l' },
                { key: 'tag', is_sort: true, classes: 'text-l' },
            ],


            tableBody: {
                'email_subscription': { type: 'function', function: this.getEmailSubscription },
                'user_id': { type: 'function', function: this.getUser },
                'industry': { type: 'function', function: this.getIndustry },
                'logo': { type: 'function', function: this.getLogo },
            },


            apiList: this.$store.getters.getApiUrl('company'),
            pageRoute: 'company',
            pageRouteCreate: 'company.create',
            pageRouteEdit: 'company.edit',
            pagePermission: 'company',
        }
    },
    methods: {
        exportData() {
            this.$store.commit('setLoading', true)
            axios
                .post(this.$store.getters.getApiUrl('companies.export'), {}, { responseType: 'blob' })
                .then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'Companies.xlsx');
                    document.body.appendChild(link);
                    link.click();
                })
                .finally(() => {
                    this.$store.commit('setLoading', false)
                })
        },
        getEmailSubscription(item) {
            if (item.email_subscription === false) {
                return 'No'
            }
            if (item.email_subscription === true) {
                return 'Yes'
            }
            return '-'
        },
        getUser(item) {
            if (item.user) {
                return '@' + item.user.name
            }
            return '-'
        },
        getIndustry(item) {
            if (item.industry) {
                return item.industry.title
            }
            return '-'
        },
        getLogo(item) {
            let image = item.logo
            if (!image) {
                image = '/images/no_image.png'
            }
            return '<img class="image-cover" style="background-image: url('+image+')">'
        }
    }
}
</script>

<style scoped>

</style>
